define((require) => {
    'use strict';

    const _ = require('lodash');

    return function compactObject(source) {
        const newSource = {};

        _.forOwn(source, (value, key) => {
            if (value) {
                newSource[key] = value;
            }
        });

        return newSource;
    };
});
